import script from "./NextSteps.vue?vue&type=script&setup=true&lang=js"
export * from "./NextSteps.vue?vue&type=script&setup=true&lang=js"

import "./NextSteps.vue?vue&type=style&index=0&id=39dd5ace&lang=scss&scoped=true"
import "./NextSteps.vue?vue&type=style&index=1&id=39dd5ace&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39dd5ace"]])

export default __exports__